import { Container } from '@amelio/ui-library';

import type { ReactNode } from 'react';

export interface ResultsContentProps {
    children: ReactNode;
}

export const ResultsContent = ({ children }: ResultsContentProps) => {
    return (
        <Container
            px={'lg'}
            py={'section'}
            borderRadius={'2xl'}
            background={'translucent'}
            className={'mt-30'}
        >
            <Container
                direction={'col'}
                className={'mx-auto w-full max-w-6xl sm:px-6'}
            >
                {children}
            </Container>
        </Container>
    );
};

export default ResultsContent;
